import React from "react";
import Modal from "react-bootstrap/Modal";
import { IPrivacyModalProps } from "./PrivacyModalProps";
import { useStaticQuery, graphql } from "gatsby";
import { StyledDialog } from "./PrivacyModalHelpers";

const PrivacyModal: React.FC<IPrivacyModalProps> = (props) => {
  const data = useStaticQuery(graphql`
    {
      allNodePage(filter: { path: { alias: { eq: "/v1/privacy" } } }) {
        edges {
          node {
            title
            path {
              alias
            }
            body {
              processed
              value
            }
          }
        }
      }
    }
  `);
  let privacy = null;
  if (data.allNodePage.edges.length) {
    privacy = data.allNodePage.edges[0].node;
  }

  return (
    <StyledDialog
      show={props.show}
      onHide={props.onHide}
      aria-label="Privacy Policy"
    >
      <Modal.Header closeButton>
        <Modal.Title id="privacy-policy-modal">Privacy Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {privacy && (
          <div dangerouslySetInnerHTML={{ __html: privacy.body?.processed }} />
        )}
      </Modal.Body>
    </StyledDialog>
  );
};
export default PrivacyModal;
